import "../App.css";
import { Container, Row, Col, Image, Button } from "react-bootstrap";

function Banner({ onLoginClick }) {
  return (
    <Container className="home-banner mb-5" fluid>
      <Row>
        <Col xs={12} lg={6} className="px-5 pb-5">
          <div className="header mb-3">CTGWeb2.0</div>
          <div className="body mb-4" style={{ fontSize: "1.15rem", fontWeight: "450" }}>An online course for learning to apply Trauma-Focused Cognitive Behavioral Therapy to treatment of Childhood Traumatic Grief.</div>
          <div className="body mb-2" style={{ fontSize: "1.15rem", fontWeight: "700" }}>Fee: $20 per learner</div>
          <div className="body" style={{ fontSize: ".85rem", fontWeight: "400" }}>Mode: Online / Self-Paced</div>
          <div className="body mb-4" style={{ fontSize: ".85rem", fontWeight: "400" }}>Length: ~6 hrs</div>
          <Button className="log-button" onClick={onLoginClick}>Login with Your TF-CBTWeb2.0 Account</Button>
        </Col>
        <Col xs={12} lg={6} className="px-5 pb-5">
          <Image src="/conversation.png" alt="Therapist Speaking with a Child" style={{ borderRadius: "10px", maxHeight: "90%" }} fluid />
        </Col>
      </Row>
    </Container>
  );
}

export default Banner;
